/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Integrity_HintInputs */



/**
* | output |
* | --- |
* | "The tarball's sha512 integrity. When set, the worker refuses a package that does not match." |
*
* @param {Partner_Connectors_Field_Integrity_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_integrity_hint = /** @type {((inputs?: Partner_Connectors_Field_Integrity_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Integrity_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die sha512-Integrität des Tarballs. Ist sie gesetzt, lehnt der Worker ein abweichendes Paket ab.")
	return /** @type {LocalizedString} */ ("The tarball's sha512 integrity. When set, the worker refuses a package that does not match.")
});